import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./ProductForm";
import Loading from "../../../components/Loading";
import GraphQLErrors from "../../../components/GraphQLErrors";
import {cancelAddProductToShop} from "../../../actions/InventoryApiActions";
import {fromJS, Map, List} from "immutable";
import {validatePresence, validateGreaterThan} from "../../../lib/Validators";
import {createValidationErrors, createErrors} from "../../../lib/ErrorFormatter";
import {sellableGroups} from "../../../lib/StockHelper";

function formatProducts(products) {
  return fromJS(products).map((x) => {
    return x.set("title", `${x.get("sku")} ${x.get("title")}`);
  })
}

function transformInput(values) {
  let pricing = values.get("pricing", Map()).reduce((acc, val, key) => {
    return acc.push({
      currency: key,
      value: val
    })
  }, List());
  return values.set("pricing", pricing);
}

class AddProductToShopFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    // The data has to be translated to be sent out.
    let transValues = transformInput(values);
    return this.props.addProductToShop(transValues.set("shopId", this.props.shopId).toJS())
      .then((response) => {
        if (response.data.addProductToShop.errors.length <= 0) {
          this.props.cancelAddProductToShop();
        } else {
          let errors = createValidationErrors(response.data.addProductToShop.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelAddProductToShop();
  }

  validateForm(values) {
    let shop = fromJS(this.props.data.shop);
    let errors = Map();
    errors = validatePresence(errors, values, "productSku");
    // Check currency errors.
    let currencyErrors = shop.get("currencies").reduce((acc, currency) => {
      return validateGreaterThan(acc, values.get("pricing", Map()), currency, 0);
    }, Map());
    // Merge into errors when present.
    if (currencyErrors.size > 0) {
      errors = errors.set("pricing", currencyErrors);
    }
    return errors.toJS();
  }

  render() {
    let {data} = this.props;
    if (data.loading) return <Loading />
    if (data.error) return <GraphQLErrors error={data.error} />
    let formattedProducts = formatProducts(data.sellableProducts)
    let shop = fromJS(data.shop);
    return (
      <Form
        currencies={shop.get("currencies")}
        products={formattedProducts}
        groups={sellableGroups()}
        errors={this.state.errors}
        validate={this.validateForm.bind(this)}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }

}


const CREATE_PRODUCT_BUNDLE = gql`
  mutation addProductToShop($data: ProductBundleInput!) {
    addProductToShop(input: $data) {
      errors { key message }
    }
  }
`;

const GET_SHOP_AND_PRODUCTS = gql`
  query shop($shopId: ID!) {
    shop(shopId: $shopId) {
      shopId
      title
      currencies
    }
    sellableProducts {
      sku
      title
      type
    }    
  }
`;

const withProductQuery = compose(
  graphql(GET_SHOP_AND_PRODUCTS, {
    options: (props) => ({
      variables: {
        shopId: props.shopId
      }
    })
  }),
  graphql(CREATE_PRODUCT_BUNDLE, {
    props: ({ mutate }) => ({
      addProductToShop: (data) => mutate({
        variables: { data: data }
      })
    })
  })  
);

const AddProductToShopFormContainerWithData = withProductQuery(AddProductToShopFormContainer);

export default connect(null, {cancelAddProductToShop})(AddProductToShopFormContainerWithData);